import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import Gem from "./Gem";
import ABCyaLib from "@abcya/abcya_lib";

export default class NavBar extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);
        this.setDepth(5);

        this.scene = scene;
        this.spacer = 20;
        this.score = 0;
        this.points = 0;
        this.previousInd = 0;
        this.clusterLen = 0;
        this.levelInd = 1;
        this.fSize = 30;
        this.answerArr = [];

        if(gameData.GAME_MODE != "arcade")
        {
            this.maxScoreInd = 100;
        } else {
            this.maxScoreInd = 50;
        }
        this.maxScore = "/" + this.maxScoreInd;
		
        this.createNav();
        this.toggleInstructions("on");
    }

	createNav() {
        this.navContTop = this.scene.add.container().setDepth(5);
        this.navContBot = this.scene.add.container().setDepth(5);
        this.scoreCont = this.scene.add.container().setDepth(5);
        this.pointsCont = this.scene.add.container().setDepth(5);
        this.sndBtnCont = this.scene.add.container().setDepth(5);
        this.instCont = this.scene.add.container().setDepth(5);
        this.questionCont = this.scene.add.container().setDepth(5);
        this.block1Cont = this.scene.add.container().setDepth(5);
        this.block2Cont = this.scene.add.container().setDepth(5);
        this.block3Cont = this.scene.add.container().setDepth(5);

        this.scorePanel = ABCyaPhaser.Images.addImage(0, 0, "GemCounterBar", this.scoreCont);
        this.inst = ABCyaPhaser.Images.addImage(0, 0, "InstructionsArea", this.instCont);
        this.bg = ABCyaPhaser.Images.addImage(0, 0, "TopBar", this.navContTop);
        this.bgB = ABCyaPhaser.Images.addImage(0, 0, "BottomBar", this.navContTop);
        this.questionBG = ABCyaPhaser.Images.addImage(0, 0, "QuestionArea", this.questionCont);
        this.pointsBG = ABCyaPhaser.Images.addImage(0, 0, "ScoreCounterBar", this.pointsCont);
        
        this.soundBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "MuteBtn", null, ()=>{
            this.toggleSound();
        }, this.sndBtnCont, {disabledTint:"0xFFFFFF"}).setEnabled(false);
        this.muteBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "UnmuteBtn", null, ()=>{
            this.toggleSound();
        }, this.sndBtnCont, {disabledTint:"0xFFFFFF"}).setEnabled(false);

        this.pauseBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "MenuBtn", null, ()=>{
            this.clickHandler("pause");
        }, this.navContTop, {disabledTint:"0xFFFFFF"}).setEnabled(false);

        this.block1 = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "AnswerBtn", null, ()=>{
            this.clickHandler(this.block1Cont);
        }, this.block1Cont, {disabledTint:"0xFFFFFF"}).setEnabled(false);
        this.block2 = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "AnswerBtn", null, ()=>{
            this.clickHandler(this.block2Cont);
        }, this.block2Cont, {disabledTint:"0xFFFFFF"}).setEnabled(false);
        this.block3 = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "AnswerBtn", null, ()=>{
            this.clickHandler(this.block3Cont);
        }, this.block3Cont, {disabledTint:"0xFFFFFF"}).setEnabled(false);

        if(gameData.GAME_MODE == "arcade"){
            this.skip = ABCyaPhaser.Buttons.addSimpleButton(150, 700, "SkipBtn", null, ()=>{
                this.clickHandler("skip");
            }, this.scene, {disabledTint:"0xFFFFFF"}).setEnabled(false).setScale(0);
        }

        this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, this.fSize, "0xFFFFFF", gameData.GAME_FONTS[1], String(this.score), this.scoreCont);
        this.pointsTxt = ABCyaPhaser.Text.addText(0, 0, 40, "0xFFFFFF", gameData.GAME_FONTS[1], String(this.points), this.pointsCont);
        this.scoreBaseTxt = ABCyaPhaser.Text.addText(0, 0, 30, "0xFFB42E", gameData.GAME_FONTS[1], this.maxScore, this.scoreCont);
        this.instTxt = ABCyaPhaser.Text.addText(0, 0, this.fSize, "0xFFB42E", gameData.GAME_FONTS[0], "Drag across gems with the same number", this.instCont);
        this.questionTxt = ABCyaPhaser.Text.addText(0, 0, 48, "0xFFB42E", gameData.GAME_FONTS[1], "x " + " " + " =", this.questionCont);
        this.factorTxt = ABCyaPhaser.Text.addText(0, 0, 48, "0xFFB42E", gameData.GAME_FONTS[1], "0", this.questionCont);
        this.block1Txt = ABCyaPhaser.Text.addText(0, 0, 60, "0xFFFFFF", gameData.GAME_FONTS[1], "144", this.block1Cont);
        this.block2Txt = ABCyaPhaser.Text.addText(0, 0, 60, "0xFFFFFF", gameData.GAME_FONTS[1], "144", this.block2Cont);
        this.block3Txt = ABCyaPhaser.Text.addText(0, 0, 60, "0xFFFFFF", gameData.GAME_FONTS[1], "144", this.block3Cont);
        if(gameData.GAME_MODE == "arcade")
        {
            this.levelTxt = ABCyaPhaser.Images.addImage(0, 0, "HowToPlayBanner", this);
        } else {
            this.levelTxt = ABCyaPhaser.Images.addImage(0, 0, "Level" + gameData.GAME_LEVEL + "Banner", this);
        }

        this.answerArr.push(this.block1Txt, this.block2Txt, this.block3Txt);

        this.scoreTxt.x = -this.scorePanel.width/7 + 15;
        this.scoreBaseTxt.x = this.scorePanel.width/6 + 10;

        //position all the elements of the nav bar
        this.muteBtn.visible = false;
        this.soundBtn.visible = true;
        this.sndBtnCont.name = "soundCont";

        this.bg.x = this.bgB.x = this.scene.mid.x - 3;
        this.bg.y = 50;
        this.bgB.y = this.scene.mid.y*2 - this.bg.height/2 + 20;
        this.instCont.x = this.scene.mid.x;
        this.instCont.y = this.scene.mid.y*2 - this.inst.height + 5;

        this.pauseBtn.scaleX = this.pauseBtn.scaleY =
            this.sndBtnCont.scaleX = this.sndBtnCont.scaleY =
                this.scoreCont.scaleX = this.scoreCont.scaleY =
                    this.pointsCont.scaleX = this.pointsCont.scaleY = 0;
        this.instCont.scaleX = this.instCont.scaleY = 0;

        this.questionBG.x = this.questionBG.width/2;
        this.questionBG.y = this.scene.mid.y*2 - this.questionBG.height/2 - 28;
        this.questionBG.scaleX = this.questionBG.scaleY = .94;
        this.questionTxt.x = this.questionBG.x + 50;
        this.questionTxt.y = this.questionBG.y - 3;
        this.factorTxt.x = this.questionTxt.x;
        this.factorTxt.y = this.questionTxt.y;
        this.questionCont.alpha = 0;

        this.block1Cont.x = this.questionBG.x + this.questionBG.width - this.block1.width + 30;
        this.block2Cont.x = this.block1Cont.x + this.block2.width;
        this.block3Cont.x = this.block2Cont.x + this.block3.width;
        this.block1Cont.y = this.block2Cont.y = this.block3Cont.y = this.questionBG.y;
        this.block1Cont.scaleX = this.block1Cont.scaleY =
            this.block2Cont.scaleX = this.block2Cont.scaleY =
                this.block3Cont.scaleX = this.block3Cont.scaleY = 0;
        this.block1Txt.y = this.block2Txt.y = this.block3Txt.y = -4;
        this.block1Txt.x = this.block2Txt.x = this.block3Txt.x = -2;

        this.scoreCont.x = this.scene.mid.x*2 - this.scorePanel.width/2 - 10;
        this.scoreCont.y = this.pointsCont.y = this.scorePanel.height/2 + 15;

        this.pauseBtn.x = this.pauseBtn.width/2 + 10;
        this.sndBtnCont.x = this.pauseBtn.x + this.muteBtn.width + 5;
        this.sndBtnCont.y = this.pauseBtn.y = this.pauseBtn.height/2 + 5;

        this.pointsCont.x = this.scoreCont.x - this.pointsBG.width - 20;
        this.pointsTxt.x = 10;

        this.sndBtnCont.x + this.scorePanel.width - 45;

        this.levelTxt.scaleX = this.levelTxt.scaleY = 0;
        this.levelTxt.x = this.scene.mid.x;
        this.levelTxt.y = this.scene.mid.y;

        //add all the elements to the screen
        this.navContTop.add(this.sndBtnCont, this.scoreCont, this.pointsCont);
        this.navContBot.add(this.instCont, this.questionCont, this.block1Cont, this.block2Cont, this.block3Cont);
        this.add(this.navContTop, this.navContBot);

        ABCyaPhaser.Audio.playOneShot("New_Level_Whoosh", this.scene);

        //tween in the nav bar then start the clock
        ABCyaPhaser.Tweens.addTween(this.levelTxt, 1500, {scale:1.25}, Phaser.Math.Easing.Back.Out, ()=>{this.textReady("init");});
        ABCyaPhaser.Tweens.addTween(this.pauseBtn, 500, {scale:.8}, Phaser.Math.Easing.Back.Out);
        ABCyaPhaser.Tweens.addTween(this.sndBtnCont, 500, {scale:.8, delay:100}, Phaser.Math.Easing.Back.Out);
        ABCyaPhaser.Tweens.addTween(this.pointsCont, 500, {scale:1, delay:300}, Phaser.Math.Easing.Back.Out);
        ABCyaPhaser.Tweens.addTween(this.scoreCont, 500, {scale:1, delay:400}, Phaser.Math.Easing.Back.Out);
	};

    textReady(type){
        if(type == "init"){
            ABCyaPhaser.Audio.playOneShot("New_Level_Whoosh", this.scene);

            ABCyaPhaser.Tweens.addTween(this.levelTxt, 1000, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{this.navReady("init");});
        } else if(type == "end"){
            ABCyaPhaser.Tweens.addTween(this.levelTxt, 1000, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{this.scene.showPopup("end");});
        } else {
            //console.log("TEXT READY FOR LEVEL BANNER");
            ABCyaPhaser.Tweens.addTween(this.levelTxt, 1000, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{this.scene.time.delayedCall(50, ()=>{this.levelBanner("in");});});
        }
    };

    levelBanner(type){
        if(type == "in"){
            //console.log("TWEENING IN BANNER");
            this.levelTxt.destroy();
            this.levelTxt = null;

            this.levelTxt = ABCyaPhaser.Images.addImage(0, 0, "Level" + gameData.GAME_LEVEL + "Banner", this);

            this.levelTxt.scaleX = this.levelTxt.scaleY = 0;
            this.levelTxt.x = this.scene.mid.x;
            this.levelTxt.y = this.scene.mid.y;

            ABCyaPhaser.Audio.playOneShot("New_Level_Whoosh", this.scene);

            ABCyaPhaser.Tweens.addTween(this.levelTxt, 1500, {scale:1.25}, Phaser.Math.Easing.Back.Out, ()=>{this.levelBanner("out");});
        }
        if(type == "out"){
            ABCyaPhaser.Tweens.addTween(this.levelTxt, 1000, {scale:0}, Phaser.Math.Easing.Back.In, ()=>{this.navReady();});
        }
    };

    navReady(type){
        //start setTimer clock and add button listeners
        if(type == "init"){
            this.scene.gemArea.startInstructions();
            if(this.skip) ABCyaPhaser.Tweens.addTween(this.skip, 500, {scale:1}, Phaser.Math.Easing.Back.Out, ()=>{this.addSkip();});
        } else {
            this.setListeners("on");
            this.scene.gemArea.setUI(true);
        }
    };

    addSkip() {
        if(gameData.GAME_LEVEL == 0) this.skip.setEnabled(true);
    };


    createQuestion(len, ind, released){
        //console.log("creating question");
        if(this.prevQ && released) {
            console.log("Q = " + this.prevQ + " and len = " + len);
            if (this.prevQ != len) {
                this.createAnswers(len, ind);
                this.prevQ = len;
            }
        } else {
            this.prevQ = len;
        }

        this.points = ind;

        if(this.factorTxt.text != String(len)){
            if(this.answerGem){
                this.answerGem.destroy();
                this.answerGem = null;
            }

            this.answerGem = new Gem(this.scene, this, ind, ind);
            this.questionCont.add(this.answerGem);

            this.answerGem.scaleX = this.answerGem.scaleY = .9;

            this.answerGem.x = 78;
            this.answerGem.y = this.questionBG.y;

            this.factorTxt.scaleX = this.factorTxt.scaleY = 2;
            this.factorTxt.text = String(len);

            if(this.factorTxt.text.length == 1){
                this.factorTxt.x = this.questionTxt.x;
                ABCyaPhaser.Tweens.addTween(this.factorTxt, 150, {scale:1}, Phaser.Math.Easing.Linear);
            }
            if(this.factorTxt.text.length == 2){
                // this.factorTxt.x = this.questionTxt.x - 40;
                this.factorTxt.y = this.questionTxt.y + 3;
                ABCyaPhaser.Tweens.addTween(this.factorTxt, 150, {scale:.95}, Phaser.Math.Easing.Linear);
            }

            ABCyaPhaser.Tweens.addTween(this.questionCont, 250, {alpha:1}, Phaser.Math.Easing.Linear);
        }
    };

    createAnswers(len, ind){
        //console.log("creating question for " + ind);
        ABCyaPhaser.Arrays.shuffle(this.answerArr);

        let answer = len*ind;
        gameData.ANSWER = answer;

        let answers = [];

        if(ind == 1){
            answers.push(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13);
        }
        if(ind == 2){
            answers.push(2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26);
        }
        if(ind == 3){
            answers.push(3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39);
        }
        if(ind == 4){
            answers.push(4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52);
        }
        if(ind == 5){
            answers.push(5, 10, 15, 20, 30, 35, 40, 45, 50, 55, 60, 65, 70);
        }
        if(ind == 6){
            answers.push(6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78);
        }
        if(ind == 7){
            answers.push(7, 14, 21, 28, 35, 42, 49, 56, 63, 70, 77, 84, 91);
        }
        if(ind == 8){
            answers.push(8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104);
        }
        if(ind == 9){
            answers.push(9, 18, 27, 36, 45, 54, 63, 72, 81, 90, 99, 108, 117);
        }
        if(ind == 10){
            answers.push(10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130);
        }
        if(ind == 11){
            answers.push(11, 22, 33, 44, 55, 66, 77, 88, 99, 110, 121, 132, 143);
        }
        if(ind == 12){
            answers.push(12, 24, 36, 48, 60, 72, 84, 96, 108, 120, 132, 144, 156);
        }

        ABCyaPhaser.Arrays.shuffle(answers);
        if(answers.indexOf(answer) != -1){
            answers.splice(answers.indexOf(answer), 1);
        }

        let randHigh = answers[Phaser.Math.Between(0,answers.length-1)];
        answers.splice(answers.indexOf(randHigh), 1);
        let randLow = answers[Phaser.Math.Between(0,answers.length-1)];

        let randArr = [randHigh, randLow];
        ABCyaPhaser.Arrays.shuffle(randArr);

        let answer1 = randArr[0];
        let answer2 = randArr[1];
        let randomizeBlocks = Phaser.Math.Between(0,2);

        if(gameData.GAME_LEVEL == 0){
            this.scene.gemArea.moveHand("answer", randomizeBlocks);
        }

        if(randomizeBlocks == 0){
            this.answerArr[0].text = String(answer);
            this.answerArr[1].text = String(answer1);
            this.answerArr[2].text = String(answer2);
        }
        if(randomizeBlocks == 1){
            this.answerArr[0].text = String(answer1);
            this.answerArr[1].text = String(answer);
            this.answerArr[2].text = String(answer2);
        }
        if(randomizeBlocks == 2){
            this.answerArr[0].text = String(answer1);
            this.answerArr[1].text = String(answer2);
            this.answerArr[2].text = String(answer);
        }

        this.playSound();

        ABCyaPhaser.Tweens.addTween(this.block1Cont, 300, {scale:.8}, Phaser.Math.Easing.Back.Out);
        ABCyaPhaser.Tweens.addTween(this.block2Cont, 300, {scale:.8, delay:50}, Phaser.Math.Easing.Back.Out);
        ABCyaPhaser.Tweens.addTween(this.block3Cont, 300, {scale:.8, delay:100}, Phaser.Math.Easing.Back.Out, ()=>{this.setListeners("answer");});
    };

    setListeners(type){
        //turn on the menu button and the sound button click listener
        if(type == "on"){
            if(!gameData.GAME_PAUSED){
                this.pauseBtn.setEnabled(true);

                gameData.MUTE ? this.muteBtn.setEnabled(true) :  this.soundBtn.setEnabled(true);
            }
        }
        //turn off the menu button and the sound button click listener
        if(type == "off"){
            this.pauseBtn.setEnabled(false);
            this.muteBtn.setEnabled(false);
            this.soundBtn.setEnabled(false);
            this.block1.setEnabled(false);
            this.block2.setEnabled(false);
            this.block3.setEnabled(false);

            if(gameData.GAME_LEVEL == 0){
                this.skip.setEnabled(false);
            }
        }

        if(type == "answer"){
            if(!gameData.GAME_PAUSED && !gameData.GAME_DONE){
                this.scene.gemArea.setUI(true);

                this.block1.setEnabled(true);
                this.block2.setEnabled(true);
                this.block3.setEnabled(true);
            }
        }
    };

    playSound(){
        //console.log("playing block sound");
        ABCyaPhaser.Audio.playOneShot("answer_choices", this.scene);
    };

    toggleAnswer(type){
        if(type == "on"){
            if(!gameData.GAME_PAUSED){
                this.playSound();

                ABCyaPhaser.Tweens.addTween(this.block1Cont, 300, {scale:.8}, Phaser.Math.Easing.Back.Out);
                ABCyaPhaser.Tweens.addTween(this.block2Cont, 300, {scale:.8, delay:100}, Phaser.Math.Easing.Back.Out);
                ABCyaPhaser.Tweens.addTween(this.block3Cont, 300, {scale:.8, delay:200}, Phaser.Math.Easing.Back.Out, ()=>{this.setListeners("answer");});
            }
        }
        if(type == "off"){
            this.block1.setEnabled(false);
            this.block2.setEnabled(false);
            this.block3.setEnabled(false);
            this.block1Cont.scaleX = this.block1Cont.scaleY = 0;
            this.block2Cont.scaleX = this.block2Cont.scaleY = 0;
            this.block3Cont.scaleX = this.block3Cont.scaleY = 0;
        }
    };

    toggleInstructions(type, spd){
        if(type == "on"){
            if(!gameData.GRABBING){
                this.factorTxt.text = "0";

                if(spd == "fast"){
                    this.instCont.scaleX = this.instCont.scaleY = 1;
                    this.scene.tweens.killTweensOf(this.questionCont);
                    ABCyaPhaser.Tweens.addTween(this.questionCont, 20, {alpha:0}, Phaser.Math.Easing.Linear);
                } else {
                    this.scene.tweens.killTweensOf(this.instCont);
                    this.scene.tweens.killTweensOf(this.questionCont);
                    ABCyaPhaser.Tweens.addTween(this.instCont, 500, {scale:1}, Phaser.Math.Easing.Back.Out);
                    ABCyaPhaser.Tweens.addTween(this.questionCont, 200, {alpha:0}, Phaser.Math.Easing.Linear, ()=>{this.clearGem();});
                }

                ABCyaPhaser.Tweens.addTween(this.block1Cont, 200, {scale:0}, Phaser.Math.Easing.Linear);
                ABCyaPhaser.Tweens.addTween(this.block2Cont, 200, {scale:0, delay:100}, Phaser.Math.Easing.Linear);
                ABCyaPhaser.Tweens.addTween(this.block3Cont, 200, {scale:0, delay:200}, Phaser.Math.Easing.Linear);
            }
        }
        if(type == "off"){
            this.scene.tweens.killTweensOf(this.instCont);
            this.instCont.scaleX = this.instCont.scaleY = 0;
        }
    };

    clickHandler(event){
        // console.log("clicked " + event.list[1].text);
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        this.setListeners("off");
        this.scene.gemArea.setUI(false);

        if(event == this.block1Cont || event == this.block2Cont || event == this.block3Cont)
        {
            const answer = Number(event.list[1].text);

            if(answer == gameData.ANSWER){
                // console.log("CORRECT");
                this.scene.gemArea.score("+");
    
                ABCyaPhaser.Audio.playOneShot("New_Level", this.scene);
            } else {
                // console.log("WRONG");
                this.scene.gemArea.wiggle(3, 75);
                this.scene.gemArea.score("-");
    
                ABCyaPhaser.Audio.playOneShot("Incorrect_Answer", this.scene);
            }
    
            this.scene.gemArea.prevGemInd = null;
        }
        else if(event == "pause"){
            this.scene.showPopup("pause");
        } else {
            if(gameData.GAME_LEVEL == 0){
                this.scene.tweens.killTweensOf(this.scene.gemArea.hand);
                this.scene.gemArea.hand.alpha = 0;

                if(event == "skip"){
                    this.scene.gemArea.destroyLevel(true);
                }
            }
        }
    };

    clearGem(){
        this.answerGem?.destroy();
        this.answerGem = null;
    };

    toggleSound(){
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        //If the sound btn is showing, mute all sounds and show mute btn
        if(gameData.MUTE == false){
            // console.log("Sound muted");
            gameData.MUTE = true;

            this.muteBtn.visible = true;
            this.soundBtn.visible = false;

            this.muteBtn.setEnabled(true);
            this.soundBtn.setEnabled(false);
        } else {
            // console.log("Sound on");
            gameData.MUTE = false;

            this.muteBtn.visible = false;
            this.soundBtn.visible = true;

            this.muteBtn.setEnabled(false);
            this.soundBtn.setEnabled(true);
        }

        this.scene.jingle.mute = gameData.MUTE;
    };

    checkLevel(){
        this.setListeners("off");
        this.scene.gemArea.setUI(false);

        if(gameData.GAME_MODE == "arcade"){
            if(gameData.GAME_LEVEL != 4){
                if(this.score >= this.maxScoreInd){
                    gameData.GAME_DONE = true;
                    // console.log("CHANGING LEVEL");
                    this.score = 0;
                    gameData.GAME_LEVEL++;

                    this.levelTxt.destroy();
                    this.levelTxt = null;

                    this.scoreTxt.scaleX = this.scoreTxt.scaleY = 1;
                    this.scoreTxt.text = String(this.score);
                    this.scoreTxt.x = -this.scorePanel.width/7 + 15;

                    this.levelTxt = ABCyaPhaser.Images.addImage(0, 0, "LevelCompleteBanner", this);

                    this.levelTxt.scaleX = this.levelTxt.scaleY = 0;
                    this.levelTxt.x = this.scene.mid.x;
                    this.levelTxt.y = this.scene.mid.y;

                    ABCyaPhaser.Audio.playOneShot("Level_Complete_Whoosh", this.scene);

                    this.scene.time.delayedCall(300, ()=>{this.scene.gemArea.checkForSpecial();});

                    if(gameData.GAME_LEVEL != 4){
                        ABCyaPhaser.Tweens.addTween(this.levelTxt, 1500, {scale:1.25}, Phaser.Math.Easing.Back.Out, ()=>{this.textReady();});
                    } else {
                        gameData.GAME_END = true;
                        ABCyaPhaser.Tweens.addTween(this.levelTxt, 1500, {scale:1.25}, Phaser.Math.Easing.Back.Out, ()=>{this.textReady("end");});
                    }
                }
            }
        } else {
            // console.log("LEVELS checking scores - UNLOCK NEXT");
            if(this.score >= this.maxScoreInd){
                gameData.GAME_DONE = true;

                if(gameData.GAME_LEVEL < 8){
                    if(gameData.LEVELS[gameData.GAME_LEVEL+1].locked){
                        gameData.LEVELS[gameData.GAME_LEVEL+1].locked = false;

                        ABCyaLib.Storage.saveObject('levels', gameData.LEVELS);
                    }
                }

                this.scene.time.delayedCall(500, ()=>{this.scene.gemArea.checkForSpecial();});

                this.levelTxt.destroy();
                this.levelTxt = null;

                this.scoreTxt.scaleX = this.scoreTxt.scaleY = 1;
                this.scoreTxt.text = String(this.score);
                this.scoreTxt.x = -this.scorePanel.width/7 + 15;

                this.levelTxt = ABCyaPhaser.Images.addImage(0, 0, "LevelCompleteBanner", this);

                this.levelTxt.scaleX = this.levelTxt.scaleY = 0;
                this.levelTxt.x = this.scene.mid.x;
                this.levelTxt.y = this.scene.mid.y;

                ABCyaPhaser.Audio.playOneShot("New_Level", this.scene);
                ABCyaPhaser.Tweens.addTween(this.levelTxt, 1500, {scale:1.25}, Phaser.Math.Easing.Back.Out, ()=>{this.textReady("end");});
            }
        }
    };

    setScore(amount, ind, oneOf){
        // console.log("SCORING", amount);
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);
        let newPoints;

        if(oneOf){
            newPoints = amount + Number(this.pointsTxt.text);
            this.pointsTxt.scaleX = this.pointsTxt.scaleY = 2.5;
            this.pointsTxt.text = String(newPoints);

            if(this.pointsTxt.text.length == 1){
                ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:0}, Phaser.Math.Easing.Linear);
            }
            if(this.pointsTxt.text.length == 2){
                ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
            }
            if(this.pointsTxt.text.length == 3){
                ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
            }
            if(this.pointsTxt.text.length == 4){
                ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
            }
        } else {
            if(amount > 0){
                this.score++;

                newPoints = Number(this.points) + Number(this.pointsTxt.text);
                this.pointsTxt.scaleX = this.pointsTxt.scaleY = 2.5;
                this.pointsTxt.text = String(newPoints);
                this.scoreTxt.scaleX = this.scoreTxt.scaleY = 2.5;
                this.scoreTxt.text = String(this.score);

                if(this.pointsTxt.text.length == 1){
                    ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:0}, Phaser.Math.Easing.Linear);
                }
                if(this.pointsTxt.text.length == 2){
                    ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
                }
                if(this.pointsTxt.text.length == 3){
                    ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
                }
                if(this.pointsTxt.text.length == 4){
                    ABCyaPhaser.Tweens.addTween(this.pointsTxt, 150, {scale:1, x:20}, Phaser.Math.Easing.Linear);
                }

                if(this.scoreTxt.text.length == 1){
                    this.scoreTxt.x = -this.scorePanel.width/7 + 15;
                    ABCyaPhaser.Tweens.addTween(this.scoreTxt, 150, {scale:1}, Phaser.Math.Easing.Linear, ()=>{this.setScore(amount-1);});
                }
                if(this.scoreTxt.text.length == 2){
                    ABCyaPhaser.Tweens.addTween(this.scoreTxt, 150, {scale:1}, Phaser.Math.Easing.Linear, ()=>{this.setScore(amount-1);});
                }
                if(this.scoreTxt.text.length == 3){
                    ABCyaPhaser.Tweens.addTween(this.scoreTxt, 150, {scale:1}, Phaser.Math.Easing.Linear, ()=>{this.setScore(amount-1);});
                }
            } else {
                // console.log("DONE SCORING!");
                gameData.QUESTIONING = false;
                this.setListeners("on");
                this.toggleInstructions("on");
                this.checkLevel();

                //TURN ON IF USING SPECIALS!
                if(gameData.GAME_LEVEL != 0){
                    if(!gameData.GAME_DONE){
                        this.scene.time.delayedCall(500, ()=>{this.scene.gemArea.setUI(true);});
                    }
                } else {
                    this.scene.gemArea.moveHand("score");
                }

                if(this.scoreTxt.text.length == 3){
                    ABCyaPhaser.Tweens.addTween(this.scoreTxt, 150, {scale:1}, Phaser.Math.Easing.Linear);
                }

                gameData.TOTALS = [this.pointsTxt.text, this.scoreTxt.text];
            }
        }
    };

    endGame(){
        gameData.GAME_DONE = true;
        gameData.ANSWER = null;

        this.scene.gemArea.destroyLevel();
        //this.scene.showPopup("end");
        this.setListeners("off");
    };
}